import React from 'react'
import { selectIsOnboardingContext } from '../../store/ui/ui.selectors'
import AdVideo from '../advertising/AdVideo'
import { withOnlyPE } from '../Device'
import { ONE_SECOND_MS } from '../utils/date'
import DelayComponent from '../utils/DelayComponent'
import { withEverySelectorTruthy } from '../utils/react-redux'

const DELAY_BEFORE_LAUNCH = ONE_SECOND_MS

const GeoentityAdVideo = () => (
  <DelayComponent delay={DELAY_BEFORE_LAUNCH}>
    <AdVideo />
  </DelayComponent>
)

export default withOnlyPE(withEverySelectorTruthy(selectIsOnboardingContext)(GeoentityAdVideo))
